import { isEmail } from "helpers/string";
import { BaseClientEntity } from "./baseEntity.type";
import { Customer } from "./customer.type";
import { Separator } from "./separator/separator.type";
import { Uppdrag } from "./uppdrag.type";

export type Facility = BaseClientEntity & {
  name: string;
  customer: Customer;
  separatorList: Separator[];
  uppdragList: Uppdrag[];
  documentationEmail: string;
  address: string;
  postalCode: string;
  city: string;
  kommunKod: string;
  cfarNr: string;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  notes: string;
  externalId?: string;
  coordinates?: string | null;
};

export const hasValidDocumentationEmail = (facility: Facility) =>
  isEmail(facility.documentationEmail) ||
  isEmail(facility.customer.documentationEmail);

export const getDocumentationEmail = (facility: Facility) => {
  if (facility.documentationEmail) {
    return facility.documentationEmail;
  }
  if (facility.customer.documentationEmail) {
    return facility.customer.documentationEmail;
  }
  return undefined;
};
